import DomFont from '@jbhi-fi/lanyard-ui/font/DomFont';
import { styles } from './ListingBlockHeading.css';
import React from 'react';
import type { ListingBlockProps } from './ListingBlock';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';

export type ListingBlockHeadingProps = Pick<ListingBlockProps, 'heading' | 'headingAs' | 'subHeading'> & {
  headingClassName?: string;
  subHeadingClassName?: string;
  headingColor?: string;
};

export const ListingBlockHeading = ({
  heading,
  headingAs = 'h3',
  subHeading,
  headingClassName,
  subHeadingClassName,
  headingColor = 'inherit',
}: ListingBlockHeadingProps) => (
  <>
    {typeof heading === 'string' ? (
      <DomFont
        as={headingAs}
        className={classNames([styles.heading, headingClassName])}
        style={{ color: headingColor }}
      >
        {heading}
      </DomFont>
    ) : (
      heading ?? null
    )}
    {subHeading && typeof subHeading === 'string' ? (
      <p className={classNames([styles.subHeading, subHeadingClassName])}>{subHeading}</p>
    ) : (
      subHeading ?? null
    )}
  </>
);
